module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/busy_animation.9140f48c77a4b6b5193a4fb94f1206ef.svg";